import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'ImportComponent',
  setup(__props) {

const store = useStore()

// Template refs
const file = ref<HTMLInputElement | null>(null)
const loading_indicator = ref<HTMLElement | null>(null)
const loading_indicator_wrapper = ref<HTMLElement | null>(null)

// Methods
const loadData = () => {
  store.dispatch('Import/loadData')
}

const uploadFile = (payload: { file: File }) => {
  return store.dispatch('Import/uploadFile', payload)
}

const handleFileUpload = async () => {
  if (!loading_indicator.value || !file.value || !loading_indicator_wrapper.value) return
  
  const loadingEl = loading_indicator.value
  document.body.appendChild(loadingEl)
  
  const input = file.value
  const uploadedFile = input.files?.[0]
  
  if (uploadedFile) {
    await uploadFile({ file: uploadedFile })
  }
  
  input.value = ''
  loading_indicator_wrapper.value.appendChild(loadingEl)
}

// Lifecycle
onMounted(() => {
  loadData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      type: "file",
      id: "uploadQuestion",
      name: "uploadQuestion",
      ref_key: "file",
      ref: file,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (handleFileUpload()))
    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
    _createElementVNode("div", {
      class: "loading-indicator-wrapper",
      ref_key: "loading_indicator_wrapper",
      ref: loading_indicator_wrapper
    }, [
      _createElementVNode("div", {
        class: "loading",
        ref_key: "loading_indicator",
        ref: loading_indicator
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "preloader" }, [
          _createElementVNode("span"),
          _createElementVNode("span"),
          _createElementVNode("span")
        ], -1 /* CACHED */),
        _createElementVNode("span", { class: "loading-message" }, "ページをリロードしないでください", -1 /* CACHED */)
      ]))], 512 /* NEED_PATCH */)
    ], 512 /* NEED_PATCH */)
  ]))
}
}

})